/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Training_Plan_TermsInputs */

const en_service_type_training_plan_terms = /** @type {(inputs: Service_Type_Training_Plan_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`workout plan, training programme, program, online plan`)
};

const pl_service_type_training_plan_terms = /** @type {(inputs: Service_Type_Training_Plan_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plan treningowy online, rozpisanie treningu, program treningowy, rozpiska`)
};

/**
* | output |
* | --- |
* | "workout plan, training programme, program, online plan" |
*
* @param {Service_Type_Training_Plan_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_training_plan_terms = /** @type {((inputs?: Service_Type_Training_Plan_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Training_Plan_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_training_plan_terms(inputs)
	return en_service_type_training_plan_terms(inputs)
});